import React from 'react'
import AlphabetCell from '../AlphabetCell'

const KeylessDecryptionTable = ({ text, fence, rails, selectedPos }) => {

    var keyArray = [];
    for (let i = 0; i < rails; i++) {
        keyArray.push("");
    }

    // console.log("Fence in Decryption : ", fence);

    var count = 0;
    var hasToUpdate = false;

    return (
        <div style={{ textAlign: "center" }}>
            {
                keyArray.map((row, rowIndex) => (
                    <div key={Math.random()} style={{ margin: 0 }}>{
                        fence.map((col, colIndex) => {
                            // console.log("fence ka current element  : ", fence[count])
                            if (hasToUpdate){
                                count = count + 1;
                                hasToUpdate = false;
                                // console.log("Counter updated : ", count);
                            } 

                            if (count < fence.length && fence[count][1] === colIndex && fence[count][2] === rowIndex ){
                                // console.log("Match hogya column aur row : ", fence[count])
                                hasToUpdate = true;
                            } 

                            return (
                                <div key={Math.random()} style={{ display: "inline-block", margin: 0 }}>
                                    <AlphabetCell
                                        key={Math.random()}
                                        keepSmall={true}
                                        text={count < fence.length && fence[count][1] === colIndex && fence[count][2] === rowIndex ? fence[count][0] : "-" }
                                        isLast={colIndex === text.length - 1}
                                        isPlain={selectedPos[colIndex] === rowIndex}
                                        // isCipher={isDecryption ? false : colPositions[colIndex] === rowIndex && selectedCharCol === colIndex}
                                         />
                                </div>
                            )
                        }
                        )
                    }
                    <br />
                    </div>
                ))
            }
        </div>
    );

}

KeylessDecryptionTable.defaultProps = {
    isDecryption: false,
    rowPositions: []
}

export default KeylessDecryptionTable
